const RegistrationStatus = [
	{
		Text: 'New',
		Value: 1
	},
	{
		Text: 'Pending',
		Value: 2
	},
	{
		Text: 'Accepted',
		Value: 3
	},
	{
		Text: 'Rejected',
		Value: 4
	},
	{
		Text: 'Auto Approved',
		Value: 5
	}
]

const StatusList = Backbone.Collection.extend({
	initialize() {
		this.add(RegistrationStatus);
	}
});

export default StatusList;
